import { render, staticRenderFns } from "./leader-page-header.vue?vue&type=template&id=de39b15c&"
import script from "./leader-page-header.vue?vue&type=script&lang=js&"
export * from "./leader-page-header.vue?vue&type=script&lang=js&"
import style0 from "./leader-page-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports